import { selectorInert } from "../utils/a11y";

export default function () {
  const selectorDomInert = document.querySelectorAll(selectorInert);
  const dialogSuccess = document.getElementById("modalSuccessMessage");
  const dialogError = document.getElementById( "modalErrorMessage");
  const form = document.querySelector("#job-form");
  const attachment = document.querySelector("#attachment");
  const attachmentLabel = document.querySelector("[data-input-file-label");
  const attachmentLabelRequired = document.querySelector("[data-input-file-label-required]");
  const buttonSubmit = document.querySelector("#buttonSubmit");
  const buttonsClose = document.querySelectorAll('.modal-btn-close');
  const maxFileSizeInBytes = 1024 * 1024 * 2; // 2 MB
  const attachmentErrorSize = window.dictionnary.attachmentErrorSize;
  const labelAttachment = window.dictionnary.labelAttachment;

  function modalClose() {
    selectorDomInert.forEach((dom) => {
      dom.removeAttribute('inert');
    });
  }

  buttonsClose.forEach((button) => {
    button.addEventListener('click', modalClose);
  });

  if (form) {
    attachment.addEventListener("change", (event) => {
      let file = null;

      if (attachment.files && attachment.files.length >= 1) {
        file = attachment.files[0];
        attachmentLabel.innerText = file.name;
        attachmentLabelRequired.style.display = "none";

        if (file.size > maxFileSizeInBytes) {
          attachment.setCustomValidity(attachmentErrorSize);
          attachment.reportValidity();
        } else {
          attachment.setCustomValidity("");
        }
      }
    });

    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      const formData = new FormData(form);
      let result;

      try {
        toggleStateButton(true, buttonSubmit);

        const response = await fetch("https://gdsbifq6bc2qg37h62wzvbjphq0axbuh.lambda-url.ca-central-1.on.aws/", {
          method: "POST",
          body: formData,
        });
        result = await response.json();
      } catch (error) {
        dialogError.showModal();
        selectorDomInert.forEach((dom) => {
          dom.setAttribute("inert", "");
        });
      }

      // success
      if (result?.success) {
        dialogSuccess.showModal();
        selectorDomInert.forEach((dom) => {
          dom.setAttribute("inert", "");
        });

        resetInputs();
        return;
      }

      // error
      dialogError.showModal();
      toggleStateButton(false, buttonSubmit);
    });
  }

  function resetInputs() {
    const inputs = document.querySelectorAll('input[type="text"], input[type="email"], textarea');

    inputs.forEach((input) => {
      input.value = "";
	  });

    attachmentLabel.innerText = labelAttachment;
    attachmentLabelRequired.style.display = "inline";

    toggleStateButton(false, buttonSubmit);
  }

  function toggleStateButton(state, button) {
    const buttonSubmitLabel = button.querySelector(".label");
    const buttonSubmitSpinner = button.querySelector(".spinner");

    if (state) {
      buttonSubmitLabel.classList.add("!hidden");
      buttonSubmitSpinner.classList.remove("!hidden");
      button.setAttribute('disabled', '');
      return;
    }

    buttonSubmitLabel.classList.remove("!hidden");
    buttonSubmitSpinner.classList.add("!hidden");
    button.removeAttribute('disabled');
  }
}
